import { getAllMessagesFromQueueCookie } from '../api/services/messages';

export const MESSAGE_CONTEXTS = {
	EMAIL_CONFIRMATION: ['emailConfirmation', 'emailConfirm'],
	EMAIL_CHANGE: ['emailChange'],
};

export const DEFAULT_ERROR_CODE = 'server.error.defaultMessage';

export const readAllMessages = function() {
	const messages = getAllMessagesFromQueueCookie();

	// Uncomment this to test messages locally.
	// const messages = [{
	// 	'type': 'SUCCESS',
	// 	'code': 'be.api.emailConfirmation.mailConfirmed',
	// 	'description': null,
	// 	'context': 'emailConfirmation'
	// },
	// {
	// 	'type': 'ERROR',
	// 	'code': 'be.api.emailConfirmation.confirmationCodeInvalid',
	// 	'description': null,
	// 	'context': 'emailConfirmation'
	// }];


	return messages;
};
